<template>
  <div>
    <background-wrapper src="blog/fullscreen-image_post-hero" ext="svg" :media="false">
      <div class="hero"></div>
    </background-wrapper>
    <article class="single-post">
      <b-link class="single-post__back" to="/blog">
        <img src="@/assets/arrow-left-small.svg">
        {{$t(`${$route.name}.back-to-blog-list`)}}
      </b-link>
      <div class="post post--big">
        <div class="post__image">
          <img :src="$cmsDomain + post.image" v-if="post.image">
        </div>
        <div class="post__info">
          <span class="post__category-name">{{post.category}}</span>
          <h1 class="post__title">{{post.title}}</h1>
          <time class="post__created-at">{{formatDate(post.publishedDate)}}</time>
        </div>
      </div>
      <container-small class="mt-6">
        <div class="body">
          <b-nav class="body__social-links" vertical>
            <b-nav-item to="#" @click="linkedInShare(post)"><img class="mx-n1" src="@/assets/linkedin-icon-blue.svg"/></b-nav-item>
            <b-nav-item to="#" @click="twitterShare(post)"><img class="mx-n1" src="@/assets/twitter-icon-blue.svg"/></b-nav-item>
            <b-nav-item to="#" @click="facebookShare(post)"><img class="mx-n1" src="@/assets/facebook-icon-blue.svg"/></b-nav-item>
          </b-nav>
          <div class="body__content">
            <p class="mb-4" v-if="post.content" v-html="replaceFont(post.content)"/>
            <div class="download-now" v-if="false">
              <div class="download-now__text">
                <h2 class="h3">{{$t(`${$route.name}.download-free-guide`)}}</h2>
                <b-btn variant="primary">{{$t('download-now')}}</b-btn>
              </div>
              <img src="@/assets/blog/download-guide.svg" class="download-now__image">
            </div>
            <div class="tags mt-4" v-if="post.tags">
              <h3 class="h6 tags__title">{{$t(`${$route.name}.tags`)}}</h3>
              <div class="tags__list">
                <router-link class="tag" v-for="tag in post.tags" :key="tag" :to="{ name: 'Tag', params: { id: tag } }">
                  {{tag}}
                </router-link>
              </div>
            </div>
          </div>
        </div>
      </container-small>
    </article>
    <div v-if="relatedPosts.length" class="related">
      <div class="d-flex align-items-center justify-content-between mb-3">
        <h2 class="h2 mb-0" v-html="$t(`${$route.name}.related`)"/>
        <b-link class="font-weight-bold" to="/blog">{{$t(`${$route.name}.see-all`)}}</b-link>
      </div>
      <VueSlickCarousel class="related__posts" :dots="true" v-bind="settings">
        <Post class="related__post" v-for="post in relatedPosts" :post="post" :key="post.title" vertical/>
      </VueSlickCarousel>
    </div>
    <background-wrapper src="blog/fullscreen-image_subscribe" ext="png">
      <div class="subscribe subscribe-hs-area">
        <text-container size="lg" align-center justify-center>
          <h2 class="h2" v-html="$t('Blog.subscribe.title')"/>
          <div id="hubspotForm" v-once />
        </text-container>
      </div>
    </background-wrapper>
  </div>
</template>

<script>
import VueSlickCarousel from 'vue-slick-carousel'
import 'vue-slick-carousel/dist/vue-slick-carousel.css'
import 'vue-slick-carousel/dist/vue-slick-carousel-theme.css'
import dayjs from 'dayjs'
import { Post } from '@/components/ui/blog'

export default {
  name: 'BlogPost',
  metaInfo () {
    return {
      title: this.post.title,
      meta: [
        { name: 'description', content: this.post.seoDescription },
        { name: 'twitter:title', content: this.post.title },
        { name: 'twitter:description', content: this.post.seoDescription },
        { property: 'og:title', content: this.post.title },
        { property: 'og:description', content: this.post.seoDescription }
      ]
    }
  },
  data () {
    return {
      // posts,
      post: {},
      relatedPosts: [],
      settings: {
        slidesToShow: 3,
        slidesToScroll: 1,
        speed: 1000,
        responsive: [
          {
            breakpoint: 769,
            settings: {
              slidesToShow: 2
            }
          },
          {
            breakpoint: 600,
            settings: {
              slidesToShow: 1
            }
          }
        ]
      }
    }
  },
  beforeMount () {
    this.axios.get(`${process.env['CMS_DOMAIN']}/api/blog/posts/` + this.$route.params.id)
      .then(data => {
        this.post = data.data
        this.relatedPosts = this.post.relatedPosts || []
      })
      .catch(err => {
        console.log(err)
        this.post = {}
      })

    const script = document.createElement('script')
    script.src = 'https://js.hsforms.net/forms/v2.js'
    document.body.appendChild(script)
    script.addEventListener('load', () => {
      if (window.hbspt) {
        window.hbspt.forms.create({
          css: '',
          portalId: '1890515',
          formId: '8295e7a6-d7b2-4566-8cd3-11bdae96c455',
          locale: this.$i18n.locale,
          submitButtonClass: 'hide-input hs-replace subscribe-btn',
          target: '#hubspotForm'
        })
      }
    })
  },
  mounted () {
    if (!this.relatedPosts.length) {
      this.axios.get(`${process.env['CMS_DOMAIN']}/api/blog/posts`)
        .then(data => {
          this.relatedPosts = data.data.filter(post => post.title !== this.post.title).sort((a, b) => new Date(b.publishedDate) - new Date(a.publishedDate)).slice(0, 3)
        })
        .catch(err => {
          console.log(err)
          this.relatedPosts = []
        })
    }
  },
  computed: {
    routeNameKebab: app => app.$toKebabCase(app.$route.name)
  },
  components: { VueSlickCarousel, Post },
  methods: {
    formatDate (dateString) {
      const date = dayjs(dateString)
      return date.format('MMMM D, YYYY')
    },
    replaceFont (content) {
      const searchMask = 'arial, helvetica'
      const regEx = new RegExp(searchMask, 'ig')
      const replaceMask = 'lato, roboto, helvetica'

      return content.replace(regEx, replaceMask)
    },
    getWindowOptions () {
      const width = 500
      const height = 350
      const left = (window.innerWidth / 2) - (width / 2)
      const top = (window.innerHeight / 2) - (height / 2)

      return [
        'resizable,scrollbars,status',
        'height=' + height,
        'width=' + width,
        'left=' + left,
        'top=' + top
      ].join()
    },
    twitterShare (post) {
      let text = encodeURIComponent(post.title)
      let shareUrl = 'https://twitter.com/intent/tweet?url=' + location.href + '&text=' + text
      let win = window.open(shareUrl, 'ShareOnTwitter', this.getWindowOptions())
      win.opener = null
    },
    facebookShare (post) {
      let fbUrl = 'https://www.facebook.com/sharer/sharer.php?u=' + location.href
      let win = window.open(fbUrl, 'ShareOnFacebook', this.getWindowOptions())
      win.opener = null
    },
    linkedInShare (post) {
      let linkedinUrl = 'https://www.linkedin.com/shareArticle?mini=true&url=' + location.href
      let win = window.open(linkedinUrl, 'ShareOnLinkedIn', this.getWindowOptions())
      win.opener = null
    }
  }
}
</script>

<style lang="sass" scoped>
.hero
  padding-top: 415px

.single-post
  margin-top: -390px
  position: relative
  z-index: 1

  &__back
    display: inline-block
    margin-bottom: 15px
    font-weight: bold
    color: $dark
    img
      margin-right: 5px

  .body
    +media-breakpoint-up(md)
      display: flex
      padding: 0 50px

      &__social-links
        padding: 0 55px
    +media-breakpoint-down(sm)
      margin-top: -60px
      .nav
        margin-left: -10px
        margin-bottom: 20px
        flex-direction: row!important

  .download-now
    display: flex
    max-width: 700px
    background-color: rgba($primary, .2)
    border-left: solid 4px $primary

    &__text
      flex: 1
      padding: 28px 0 28px 44px

    &__image
      flex: 0 0
      display: block
      max-height: 100%
      object-fit: cover

.tags
  display: flex
  align-items: start

  &__title
    margin: 3px 15px 0 0

  &__list
    display: flex
    flex-wrap: wrap
    margin: -6px

.tag
  margin: 6px
  padding: 4px 8px
  background-color: #F5F6F8
  font-size: 14px
  font-weight: bold
  color: $dark

.related
  margin: 60px 0 140px

  &__posts
    margin: 0 -14px

  &__post
    padding: 0 14px 28px

.subscribe
  padding: 70px 0 220px

.post
  display: flex
  align-items: center
  &:not(&--big):not(&--vertical)
    padding: 20px 0
    &:not(:last-child)
      border-bottom: solid 1px #E7E7EA

  &--big
    +media-breakpoint-down(md)
      flex-direction: column

  &--vertical
    flex-direction: column

  &__image
    flex: 1
    max-width: 240px
    width: 100%
    +media-breakpoint-down(sm)
      max-width: 210px
    +media-breakpoint-down(xs)
      max-width: 150px

    img
      width: 100%
      height: 100%
      object-fit: cover

  &--big &__image
    max-width: 100%
    +media-breakpoint-up(md)
      max-width: none
      width: 100%
      padding-right: 28px

  &--vertical &__image
    max-width: 100%
    width: 100%

  &__info
    flex: 1
    padding: 28px
    padding-right: 0

  &--big &__info
    padding: 40px 0 40px 28px
    +media-breakpoint-down(sm)
      padding: 28px 0 0 0

  &--vertical &__info
    padding: 28px 0 0 0

  &__category-name
    display: inline-block
    margin-bottom: 7px
    font-size: 12px
    font-weight: bold
    text-transform: uppercase
    letter-spacing: .8px
    color: $primary

  &__title
    margin-bottom: 6px
    a
      color: $dark

  &__body
    margin-top: 18px
    margin-bottom: 10px

  &__created-at
    color: #666B75
</style>

<style lang="sass">
.subscribe-hs-area
  .hs-form
    text-align: left
    width: 100%

  .hs-error-msg, .hs-main-font-element
    color: red
    font-size: 14px

  .hs-form-required
    display: none

  .hs-email
    width: 100% !important

  .hs-email input[type='email']
    width: 100% !important
    height: 50px
    border-radius: 4px
    border: 1px solid #dedee2
    padding: 20px

  ul
    padding: 0
    margin: 0
    li
      list-style-type: none
      margin: 0
      padding: 0

  .form-columns-2
    margin: auto

  .form-columns-1
    padding: 20px 0 25px
    max-width: 675px
    font-size: 13px
    line-height: 1.54
    letter-spacing: 0.19px
    color: #28292b
    ul li label
      padding-left: 1em
      text-indent: -1em
      margin-left: 1em
      input[type='checkbox']
        margin-left: -1em
        margin-right: 1em

  .hs-submit
    text-align: center
    input[type='submit']
      width: 160px
      height: 50px
      background-color: #0072e0
      border: 1px solid #0072e0
      border-radius: .25rem
      font-size: 16px
      font-weight: bold
      font-stretch: normal
      font-style: normal
      line-height: 1.25
      letter-spacing: 0.4px
      text-align: center
      color: #ffffff
</style>



// WEBPACK FOOTER //
// src/components/blog/BlogPost.vue